import { render, staticRenderFns } from "./premium-feature-gate-company-completion.vue?vue&type=template&id=21797862&"
import script from "./premium-feature-gate-company-completion.vue?vue&type=script&lang=js&"
export * from "./premium-feature-gate-company-completion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports